import styles from './styles.css';

import Services from './services';

import AreasComponent from './areas.component';
import ZonesComponent from './zones.component';
import DoorLocksComponent from './doorLocks.component';
import TroublesComponent from './troubles.component';
import OutputsComponent from './outputs.component';
import UsersComponent from './users.component';
import CloudAccountsComponent from './cloudAccounts.component';
import DeviceAdd from './device_add';
import Keypads from './keypads.component';
import NewDevicesStatus from './new_devices_status';
import PicturesComponent from './pictures.component';
import NotificationsComponent from './notifications.component';
import PanelInfoComponent from './panelInfo.component';
import PhonesComponent from './phones.component';
import DetailsComponent from './details.component';
import emergencyPhones from './emergencyPhones.component';
import InstallerAccess from './installerAccess.component';
import Scheduler from './scheduler.component';
import ReportsComponent from './reports.component';
import UserCodeModal from './userCode'
import EmailNotificationModal from './configEmailNotification'

// Module
import routes from './routes';

import RequestsErrorHandler from './requests.error.handler';

export default angular.module('app.main.panel.module',
    [
        // Remote Access
        AreasComponent,
        ZonesComponent,
        DoorLocksComponent,
        TroublesComponent,
        OutputsComponent,
        UsersComponent,
        DeviceAdd,
        Keypads,
        NewDevicesStatus,
        PicturesComponent,
        NotificationsComponent,
        PanelInfoComponent,
        PhonesComponent,
        DetailsComponent,
        emergencyPhones,
        InstallerAccess,
        Scheduler,
        CloudAccountsComponent,
        UserCodeModal,
        EmailNotificationModal,

        // Without Remote Access
        ReportsComponent,
        // Services
        Services
    ])
    .factory('RequestsErrorHandlerFactory', RequestsErrorHandler)
    .config(['$provide', '$httpProvider', function($provide, $httpProvider) {
    $httpProvider.interceptors.push('RequestsErrorHandlerFactory');
    }])
    .config(routes)
    .name


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/index.js
 **/